if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    //custom code
    var slideCount = $('.arrows');
    var slickSlide = $('.sym-slides');

    slickSlide.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $(this).parent().find('.pagingInfo').html('<span class="slideCountItem">' + i + '</span> ' + '<span>|</span>' + ' <span class="slideCountAll">' + slick.slideCount + '</span>');
    });

    $('.gallery-secondary').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,

                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            }
        ]
    });

    

    $(slickSlide).each(function () {
        $(this).slick({
            slide: '.item',
            slideToShow: 1,
            fade: true,
            arrows: true,
            appendArrows: $(this).parent().parent().find('.arrows'),
        });
    })

    $('.other-specials-slider').slick({
        arrows: true,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,

                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 575,
                settings: "unslick"
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    })




    //Gallery
    var slideCountG = $('.arrowsGallery');
    var slickSlideG = $('.gallery-block__list');

    slickSlideG.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var iG = (currentSlide ? currentSlide : 0) + 1;
        $(this).parent().find('.pagingInfo').html('<span class="slideCountItem">' + iG + '</span> ' + '<span>|</span>' + ' <span class="slideCountAll">' + slick.slideCount + '</span>');
    });

    $(slickSlideG).each(function () {
        $(this).slick({
            slide: '.item',
            slideToShow: 1,
            fade: true,
            arrows: true,
            appendArrows: $(this).parent().find('.arrows'),
        });
    })


    $('.accommodations__filter button').click(function () {
        const thisTag = $(this).attr('data-tag');
        console.log(thisTag);
        $('.grid__col').hide();
        if(thisTag == "All"){
            $('.grid--filter > div').fadeIn();
        }else{
            $('.' + thisTag).fadeIn();
        }
        $('.accommodations__filter button').removeClass('active');
        $('.accommodations__filter button').attr('aria-selected','false');
        $(this).addClass('active');
        $(this).attr('aria-selected','true');
    })
    
    if ($(window).width() >= 575){
        $('.accommodations__filter button:first-child').click();
    }
    

    $('#acc-select').on("change", function(){
        const thisTag = $(this).val();
        console.log(thisTag);
        $('.grid__col').hide();
        $('.' + thisTag).fadeIn();
    })

    //Set tags to attractions template
    if (document.getElementById('attractions')!= null) {
        setTimeout(() => {
            const mapbutton = document.getElementById('js-expand-map')
            mapbutton.setAttribute('aria-label', 'Expand the map to full screen' );
            const myNodelist = document.querySelectorAll('.learn-more-btn');

            for (let i = 0; i < myNodelist.length; i++) {
            myNodelist[i].setAttribute('aria-label', 'Read more about this location' );
            myNodelist[i].textContent = 'Read More';
            }
        }, 1000);
        
    }
    // add aria label to contact us form button
    
    if (document.getElementById('form_id-545') != null) {
        var submitContactUs = document.getElementById("form_id-545").getElementsByClassName("form-module__submit")[0].getElementsByClassName('btn')[0];
        submitContactUs.setAttribute('aria-label', 'Submit form to contact our inn');
    }
    if (document.getElementsByClassName('footer') != null) {
        var submitSignUp = document.getElementById("email-signup").getElementsByClassName("signup-btn ")[0];
        submitSignUp.setAttribute('aria-label', 'Subscribe to our email database');
    }
    
})();